import React, { useEffect, useState } from 'react';
import { Helmet, HelmetProvider } from "react-helmet-async";
import ModalProduct from "./ModalProduct";
import ChooseYourLookItemInterface from "../../../interfaces/main/ChooseYourLookItemInterface";
import { getBaseImagePath } from "../../catalog/Utils";

export default function Modal({ item, setSelectedItem }: {
    item: ChooseYourLookItemInterface | null,
    setSelectedItem: (item: ChooseYourLookItemInterface | null) => void
}) {
    const [defaultTitle, setDefaultTitle] = useState<string>('Site Default Title');
    const [defaultDescription, setDefaultDescription] = useState<string>('Default site description');

    useEffect(() => {
        const currentTitle = document.title;
        const metaDescription = document.querySelector("meta[name='description']");
        const currentDescription = metaDescription?.getAttribute('content') || 'Default site description';

        setDefaultTitle(currentTitle);
        setDefaultDescription(currentDescription);
    }, []);

    return (
        <HelmetProvider>
            <Helmet>
                <title>{item ? item.title || defaultTitle : defaultTitle}</title>
                <meta name="description" content={item ? item.description || defaultDescription : defaultDescription} />
                <meta property="og:title" content={item ? item.title || defaultTitle : defaultTitle} />
                <meta property="og:description" content={item ? item.description || defaultDescription : defaultDescription} />
                <meta property="og:image" content={item ? getBaseImagePath() + item.image : 'Default image URL'} />
            </Helmet>

            {item && (
                <div className="modal fade modal-main modal-fashion show" style={{ zIndex: 60 }}>
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <button type="button" className="close desk" data-bs-dismiss="modal" onClick={() => {
                                setSelectedItem(null);
                            }}></button>
                            <div className="mob">
                                <div className="modal-feedback__title">
                                    <button type="button" className="ico ico-arrow-left-b" onClick={() => {
                                        setSelectedItem(null);
                                    }}></button>
                                    <h5 className="f-exp">{item.title || 'Title is missing'}</h5>
                                    <button className="btn btn-secondary modal-fashion__copy-btn mob" onClick={() => {
                                        const url = `${window.location.origin}?look=${item?.id}`;
                                        navigator.clipboard.writeText(url).then(() => {
                                            alert('URL образа скопирован в буфер обмена');
                                        });
                                    }}>
                                        <i className="ico ico-copy-white"></i>
                                    </button>
                                    <button type="button" className="close" onClick={() => {
                                        setSelectedItem(null);
                                    }}></button>
                                </div>
                            </div>
                            <div className="modal-fashion__imgs">
                                <div className="img">
                                    <img src={getBaseImagePath() + item.image} alt="" />
                                </div>
                            </div>
                            <div className="modal-body">
                                <h5 className="modal__title f-exp desk">{item.title || 'Title is missing'}</h5>
                                <button className="btn btn-secondary modal-fashion__copy-btn desk" onClick={() => {
                                    const url = `${window.location.origin}?look=${item?.id}`;
                                    navigator.clipboard.writeText(url).then(() => {
                                        alert('URL образа скопирован в буфер обмена');
                                    });
                                }}>
                                    <i className="ico ico-copy-white"></i>
                                </button>
                                <div className="modal-basket">
                                    <div className="modal-basket__body">
                                        <div className="scrollbar-inner">
                                            {item.points.map(point => (
                                                <ModalProduct key={point.uid} point={point} />
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </HelmetProvider>
    );
}